import React from 'react';

/**
 * Página Dashboard - Métricas e KPIs
 */
export const DashboardPage: React.FC = () => {
  return (
    <div className="page-container w-full h-full flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-2">
          Dashboard
        </h2>
        <p className="text-slate-600 dark:text-slate-400">
          Métricas e indicadores de performance
        </p>
      </div>
    </div>
  );
};
